import { GivelifyLabel } from '@givelify/ui';
import { SuccessIcon } from '../SuccessIcon';
import { SuccessMessageContainer } from './style';
import React from 'react';

type SuccessMessageProps = {
    text: string;
};

export const SuccessMessage: React.FC<SuccessMessageProps> = ({ text }) => {
    return (
        <SuccessMessageContainer>
            <div>
                <SuccessIcon />
            </div>
            <GivelifyLabel text={text} />
        </SuccessMessageContainer>
    );
};
